"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    StackScreenTitle: null,
    appendStackScreenTitlePropsToOptions: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get StackScreenTitle () {
        return StackScreenTitle;
    },
    get appendStackScreenTitlePropsToOptions () {
        return appendStackScreenTitlePropsToOptions;
    }
});
const _StackTitle = require("../StackTitle");
const StackScreenTitle = _StackTitle.StackTitle;
const appendStackScreenTitlePropsToOptions = _StackTitle.appendStackTitlePropsToOptions;

//# sourceMappingURL=StackScreenTitle.js.map
